// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3XYx6","col":"Table_col__ClAE_","fulfillmentStatus":"Table_fulfillmentStatus__1sGwa","emailCol":"Table_emailCol__1NDE-"};